import { createContext, useContext } from 'react';
import { IDataTableRef } from './models';

export const DataTableContext = createContext<{ api: IDataTableRef }>({
  api: {
    columns: [],
    rows: [],
  },
});

export const useDataTableContext = () => useContext(DataTableContext);
